module.exports = "/_next/static/images/icon_plus_3-7befebcd257133a51517374c9b4581fd.svg";